module.exports = __webpack_public_path__ + "img/globe_white.d955216a.svg";